import { ItfKspSwiperData, ItfKspSwiperItem, ItfKspSwiperItemModal, ItfKspSwiperItemModalItem } from './type';

export const detaultItemModalItem: ItfKspSwiperItemModalItem = {
    name: '',
    text: '',
    pc: '',
    h5: '',
};

export const detaultItemModal: ItfKspSwiperItemModal = {
    name: '',
    text: '',
    items: [detaultItemModalItem],
};

export const defaultItem: ItfKspSwiperItem = {
    name: '',
    nameColor: 'black',
    text: '',
    textColor: '#83868A',
    pc: '',
    h5: '',
    isModal: false,
    modal: detaultItemModal,
};

export const configData: ItfKspSwiperData = {
    theme: 'white',
    title: '',
    titleColor: 'black',
    items: [defaultItem],
};
